export default [
  {
    header: "برامج و أنشطة",
    icon: "CalendarIcon",
    children: [
      {
        title: "برامج المنظمة ",
        route: "ngo-programs",
        icon: "CalendarIcon",
        slug:'ngo_programs'
      },
      {
        title: "أنشطة المنظمة ",
        route: "ngo-activities",
        icon: "ClockIcon",
        slug:'ngo_activities'
      },
      {
        title: "الخطط السنوية",
        route: {
          name: "annual-plan",
          params: { year: new Date().getFullYear() },
        },
        icon: "ClipboardIcon",
        slug:'ngo_plans'
      },

      {
        title: "التعاون مع منظمات الأمم المتحدة",
        route: "un-coop-projects",
        icon: "ArchiveIcon",
        slug:'ngo_un_coop'
      },

      {
        title: "الغعاليات المُشارك بها خارج القطر",
        route: "un-coop-international-events-subscriptions",
        icon: "CalendarIcon",
        slug:'ngo_international_events_subscriptions'
      },

      {
        title: "طلبات الإنتساب لمنظمة دولية",
        route: "un-coop-I-organisations-memberships",
        icon: "CalendarIcon",
        slug:'ngo_international_organisations_memberships'
      },

      {
        title: "التعاون بين شريكين محليين",
        route: "collaboration-two-local-partners",
        icon: "ArchiveIcon",
        slug:'ngo_collaboration_two_local_partners'
      },


    ],
  },
];
